/**
 * Delayed Google Ads / GTM loader for Shopify
 * Prevents JS race conditions on initial page load
 */

(function () {
  // Safety: avoid double execution
  if (window.__ADS_LOADED__) return;
  window.__ADS_LOADED__ = true;

  // Run only after full page load
  window.addEventListener('load', function () {

    // ---- Google Tag Manager (example) ----
    // Replace GTM-XXXXXXX with your ID

    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-XXXXXXX');

    // ---- Google Ads conversion / gtag (optional) ----
    // Uncomment only if you use gtag directly

    /*
    var gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-XXXXXXX';
    document.head.appendChild(gtagScript);

    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'AW-XXXXXXX');
    */

  });
})();
